<template>
  <div class="scheme-content">
    <page-template ref="schemeTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import userPower from '@/mixin/userPower'

export default {
  mixins: [userPower],
  components: {
    pageTemplate
  },
  data() {
    return {
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: '', prop: 'name', type: 'input', ifFuzzy: true, placeholder: "请输入方案名称"},
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          callback: this.addRequisition
        },
        {
          label: '终止',
          code: 'termination',
          callback: this.toStop,
          filter: (data) => {
            return data.status == 20 ? false : true;
          }
        },
        {
          label: '复制',
          code: 'copy',
          callback: this.toCopy,
        },
      ],
      // 表格信息配置
      tableOptions: {
        tableName: 'clearTable',
        showSelect: false,
        indexShow: true,//是否显示索引
        columns: [
          {label: '门店名称', prop: 'storeName', width: '150', align: 'center'},
          {label: '方案名称', prop: 'name', width: '150', align: 'center',callback:this.activityView,},
          {
            label: '状态',
            prop: 'status',
            width: '120',
            align: 'center',
            enumData: this.$utils.getCacheStatus('csCommissionScheme.status')
          },
          {
            label: "创建时间",
            prop: "createDttm",
            width: "160",
            align: "center",
          },
          {label: '备注', prop: 'remarks', width: '125', align: 'center'},
        ],
        url: api.retail.csCommissionScheme
      },
    };
  },
  created() {

  },
  methods: {
    // 查看活动
    activityView(row){
      this.$router.push({path: '/guide/commission/scheme/add',query:{id:row.id,type:"view"}});
    },
    // 点击复制
    toCopy(row){
      this.$router.push({path: '/guide/commission/scheme/add',query:{id:row.id,type:"copy"}});
    },
    // 点击新增
    addRequisition() {
      this.$router.push({path: '/guide/commission/scheme/add'});
    },
    // 点击终止
    toStop(row) {
      this.$confirm('终止活动？确认')
        .then(_ => {
          let params = row
          params.status = 20
          this.$axios.fetchPut(api.retail.csCommissionScheme, params).then((res) => {
            if(res.code == 200){
              // this.$message.success('终止成功')
              this.$notify({
                type: "success",
                title: '终止操作',
                message: '成功',
                showClose: false,
              });
              this.$refs["schemeTemplate"].getData();
            }else{
              this.$message.error(res.errorMsg || '终止失败')
            }
          })
        })
        .catch(_ => {});
    },

  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/guide/commission/scheme.vue